export const frontmatter = {
  title: "Hello, world",
  description:
    "A short note on why I built this site, what's here, and what to expect over the coming weeks.",
  date: "2025-02-01",
  tags: ["meta", "writing"],
  readingTime: 2,
};

I've been meaning to redo this site for a while. The old one served me well, but it had grown around me — too many features I never used, too much friction to publish.

This time I'm starting from a different place. The site has three jobs:

1. Tell you who I am, briefly.
2. Host the things I write.
3. Show what I'm building, in real time.

## Why MDX

Writing in MDX means I can drop a custom React component into a paragraph whenever I need one — a live code playground, a comparison table, a callout — without breaking flow. The new components page covers everything available.

<Callout type="tip">
  See the <a href="/blog/mdx-showcase">MDX showcase</a> for a tour of every custom component.
</Callout>

## What's next

A few things I'd like to write about soon:

- The rendering pipeline behind this site
- Notes on shipping small things consistently
- A retrospective on a side project I just finished

Subscribe via RSS (coming) or follow along on GitHub.
